import { countries } from 'boot/countries';

import dictionary from './dictionary.json';

countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default {
  ...countries.getNames('en'),
  ...dictionary,
};
